import { PurchaseOffering, CycleUtils as PlatformCycleUtils } from '@wix/premium-purchase-platform/@sdk';
const convertCycleToCycleId = cycle => {
  var _cycle$cycleDuration, _cycle$cycleDuration2;
  return `${(_cycle$cycleDuration = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration.count}-${(_cycle$cycleDuration2 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration2.unit}`;
};
const convertCycleDurationToMonths = cycle => {
  const duration = cycle.cycleDuration;
  if (!(duration != null && duration.count)) {
    throw Error(`duration count is invalid, duration unit: ${duration == null ? void 0 : duration.unit}`);
  }
  switch (duration.unit) {
    case PurchaseOffering.DurationUnit.YEAR:
      return (duration == null ? void 0 : duration.count) * 12;
    case PurchaseOffering.DurationUnit.WEEK:
      return Math.round(duration.count / 4.345);
    case PurchaseOffering.DurationUnit.DAY:
      return Math.round(duration.count / 30);
    case PurchaseOffering.DurationUnit.MONTH:
      return duration.count;
    case PurchaseOffering.DurationUnit.UNKNOWN_UNIT:
    default:
      return 0;
  }
};
const convertCycleIdToCycle = cycleId => {
  if (!cycleId) {
    return null;
  }
  const [count, unit] = cycleId.split('-');
  return {
    cycleType: PurchaseOffering.CycleType.RECURRING,
    cycleDuration: {
      count: parseInt(count, 10),
      unit: unit
    }
  };
};
const isCycleEqual = (cycle1, cycle2) => {
  var _cycle1$cycleDuration, _cycle2$cycleDuration, _cycle1$cycleDuration2, _cycle2$cycleDuration2;
  if (!cycle1 || !cycle2) {
    return false;
  }
  return cycle1.cycleType === cycle2.cycleType && ((_cycle1$cycleDuration = cycle1.cycleDuration) == null ? void 0 : _cycle1$cycleDuration.count) === ((_cycle2$cycleDuration = cycle2.cycleDuration) == null ? void 0 : _cycle2$cycleDuration.count) && ((_cycle1$cycleDuration2 = cycle1.cycleDuration) == null ? void 0 : _cycle1$cycleDuration2.unit) === ((_cycle2$cycleDuration2 = cycle2.cycleDuration) == null ? void 0 : _cycle2$cycleDuration2.unit);
};
const isCycleId = cycleId => {
  if (!cycleId) {
    return false;
  }
  const [count, unit] = cycleId.split('-');
  if (!count || !unit) {
    return false;
  }
  const countNum = parseInt(count, 10);
  if (isNaN(countNum) || countNum <= 0) {
    return false;
  }
  const validUnits = [PurchaseOffering.DurationUnit.MONTH, PurchaseOffering.DurationUnit.YEAR];
  if (!validUnits.includes(unit)) {
    return false;
  }
  return true;
};
const validateCycleId = cycleId => {
  if (!isCycleId(cycleId)) {
    return null;
  }
  return cycleId;
};
const convertToBillingPaymentCycle = cycle => {
  var _cycle$cycleDuration3, _cycle$cycleDuration6;
  if ((cycle == null || (_cycle$cycleDuration3 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration3.unit) === PurchaseOffering.DurationUnit.YEAR) {
    var _cycle$cycleDuration4, _cycle$cycleDuration5;
    if (((_cycle$cycleDuration4 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration4.count) === 1) {
      return 'YEARLY';
    }
    return `YEAR${(_cycle$cycleDuration5 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration5.count}`;
  }
  if ((cycle == null || (_cycle$cycleDuration6 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration6.unit) === PurchaseOffering.DurationUnit.MONTH) {
    var _cycle$cycleDuration7;
    if (((_cycle$cycleDuration7 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration7.count) === 1) {
      return 'MONTHLY';
    }
  }
  return;
};
const sortCyclesByDuration = cycles => {
  const filteredCycles = cycles.filter(cycle => cycle !== undefined);
  return filteredCycles.sort((a, b) => {
    try {
      const aMonths = convertCycleDurationToMonths(a);
      const bMonths = convertCycleDurationToMonths(b);
      return aMonths - bMonths;
    } catch (error) {
      console.warn('Invalid cycle duration found:', error);
      return 0;
    }
  });
};
const maxCycle = cycles => {
  const sortedCycles = sortCyclesByDuration(cycles);
  if (sortedCycles.length === 0) {
    return undefined;
  }
  return sortedCycles[sortedCycles.length - 1];
};
const convertPaymentCycle = paymentCycle => {
  const cycleType = PurchaseOffering.CycleType.RECURRING;
  switch (paymentCycle) {
    case 'MONTHLY':
      return {
        cycleType,
        cycleDuration: {
          count: 1,
          unit: PurchaseOffering.DurationUnit.MONTH
        }
      };
    case 'QUARTERLY':
      return {
        cycleType,
        cycleDuration: {
          count: 3,
          unit: PurchaseOffering.DurationUnit.MONTH
        }
      };
    case 'YEARLY':
      return {
        cycleType,
        cycleDuration: {
          count: 1,
          unit: PurchaseOffering.DurationUnit.YEAR
        }
      };
    case 'YEAR2':
      return {
        cycleType,
        cycleDuration: {
          count: 2,
          unit: PurchaseOffering.DurationUnit.YEAR
        }
      };
    case 'YEAR3':
      return {
        cycleType,
        cycleDuration: {
          count: 3,
          unit: PurchaseOffering.DurationUnit.YEAR
        }
      };
    case 'YEAR5':
      return {
        cycleType,
        cycleDuration: {
          count: 5,
          unit: PurchaseOffering.DurationUnit.YEAR
        }
      };
    default:
      return {
        cycleType,
        cycleDuration: {
          count: 1,
          unit: PurchaseOffering.DurationUnit.YEAR
        }
      };
  }
};
export const CycleUtils = {
  convertCycleToCycleId,
  convertCycleIdToCycle,
  isCycleEqual,
  validateCycleId,
  convertCycleDurationToMonths,
  sortCyclesByDuration,
  maxCycle,
  convertPaymentCycle,
  convertToBillingPaymentCycle,
  ...PlatformCycleUtils
};
//# sourceMappingURL=cycle-utils.js.map